import { __rest, __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import { Card } from '@chakra-ui/react';
import React from 'react';

var SkeletonCard = function (props) {
    var children = props.children, rest = __rest(props, ["children"]);
    var borderStyle = {
        borderRadius: "8px",
        border: "1px dashed",
        background: "neutrals.200",
        padding: "24px",
        borderColor: "neutrals.500",
    };
    return (React.createElement(Card, __assign({}, borderStyle, rest), children));
};

export { SkeletonCard as default };
//# sourceMappingURL=SkeletonCard.js.map
